import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import FORM_INPUT_CLASS from './formInputClass'

const NumericMarkField = ({ mark, readonly, onChange }) => {
  // A number input reports an empty value for what it cannot represent, erasing the answer.
  const handleChange = useCallback(event => {
    if (event.target.validity.badInput)
      return
    onChange({ value: event.target.value })
  }, [onChange])

  return (
    <input
      className={`${FORM_INPUT_CLASS} tw:lg:w-1/2!`}
      disabled={readonly}
      placeholder="Saisir une valeur..."
      type="number"
      value={mark.value || ''}
      onChange={handleChange}
    />
  )
}

NumericMarkField.propTypes = {
  mark: PropTypes.shape({ value: PropTypes.string }).isRequired,
  onChange: PropTypes.func.isRequired,
  readonly: PropTypes.bool
}

NumericMarkField.defaultProps = {
  readonly: false
}

export default NumericMarkField
